import { AddCommentInterface, AddPostInterface } from 'constants/interfaces';
import * as Yup from 'yup';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

export const addPostInitialValues: AddPostInterface = {
	content: '',
	mediaItems: [],
	taggedUsers: [],
	hashTags: [],
	newHashTags: [],
};

export const addCommentInitialValues: AddCommentInterface = {
	comment: '',
	postId: null,
	parentCommentId: null,
	taggedUsers: [],
	hashTags: [],
	newHashTags: [],
};

export const addPostSchema = (translate: TranslateFunction) =>
	Yup.object()
		.shape({
			content: Yup.string(),
			mediaItems: Yup.array().max(10, translate('Validation.uploadMaxTenMedia')),
		})
		.test('at-least-one', function (value) {
			const { content, mediaItems } = value;
			if (!!content || (Array.isArray(mediaItems) && mediaItems.length > 0)) {
				return true;
			} else {
				return this.createError({
					path: 'content',
					message: translate('Validation.postContentPhotos'),
				});
			}
		});

export const addCommentSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		comment: Yup.string()
			.required(translate('Validation.required', { field: translate('Validation.comment') }))
			.trim(),
		postId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.postId') }),
		),
	});
